import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export const VendorsIntegration = () => {
  useEffect(() => {
    document.title = 'PlanOmatic - Integrations';

    return () => {
      document.title = 'PlanOmatic';
    };
  }, []);
  return <Outlet />;
};
